var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parent"},[_c('h3',[_vm._v("问卷调查")]),_c('child'),_c('div',{},[_c('br'),_c('br'),_c('p',[_vm._v("数据："+_vm._s(_vm._fatherData))])]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.getData}},[_vm._v("测试api，请看控制台")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }